import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  constructor() {

    this.arrayComponent = [
      {
        id: 'breadcrumb1',
        titulo: '2 niveles',
        subtitulo: '',
        componentRender: `
<nav aria-label="Miga de pan, usted esta en:">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a class="breadcrumb-text" href="/">Inicio</a>  
    </li>
    <li class="breadcrumb-item active aria-current="page">
      <div class="image-icon">
        <span class="breadcrumb govco-icon govco-icon-shortr-arrow"></span>
        <p class="breadcrumb-text">Trámites y servicios</p>
      </div>
    </li>
  </ol>
</nav>
`,
      },
      {
        id: 'breadcrumb2',
        titulo: '3 o más niveles',
        subtitulo: 'Cuando se muestres tres o más niveles, el último nivel se difenciará de los demás por el color.',
        componentRender: `
<nav aria-label="Miga de pan, usted esta en:">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a class="breadcrumb-text" href="/">Inicio</a>  
    </li>
    <li class="breadcrumb-item">
      <div class="image-icon">
        <span class="breadcrumb govco-icon govco-icon-shortr-arrow"></span>
        <a class="breadcrumb-text" href="/">Trámites y servicios</a>
      </div>
    </li>
    <li class="breadcrumb-item active aria-current="page">
      <div class="image-icon">
        <span class="breadcrumb govco-icon govco-icon-shortr-arrow"></span>
        <span class="breadcrumb-text">Devolución del IVA</span>
      </div>
    </li>
  </ol>
</nav>
`,
      },
    ]

    this.infoComponent = {
      titulo: "Breadcrumb",
      subtitulo: "Breadcrumb o miga de pan en español, visualmente es la ruta de navegación que ha realizado el usuario desde la página principal a la página actual. Le da la posibilidad al usuario de conocer su ubicación actual y adicionalmente permite navegar por la jerarquía de páginas de manera más fácil e intuitiva. "
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // this.componentRender = this.exampleInput.nativeElement.innerHTML;
    // this.exampleInput.nativeElement.innerHTML = ""; 
  }
}



